import { ReactNode } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { IContactFlags } from 'clickNgo/entities/contactFlag'
import { IPartner } from 'clickNgo/entities/partner/models/partner'
import { Nullable } from 'cng-common/models/utils'

export enum ContactFormMenuItems {
  Basic = 'basic',
  Additional = 'additional',
  UserRights = 'userRights',
  Campaigns = 'campaigns',
  ToolAccess = 'toolAccess',
  ContactRelinking = 'contactRelinking',
  CreateReplacementContact = 'createReplacementContact',
}

export enum ContactEditorSettingFormFields {
  ActualData = 'actualData',
  CurrentMenuItem = 'currentMenuItem',
  EditableMenuItems = 'editableMenuItems',
  ErrorMessages = 'errorMessages',
  IsReadOnly = 'isReadOnly',
  IsLoading = 'isLoading',
}

export type TContactEditorData = {
  contact: IContact
  contactFlags: IContactFlags
}

export type TContactEditorHandles = {
  onClose: () => Promise<void> | void
  onContactUpdate: (contact: Nullable<IContact>) => Promise<void> | void
  onContactFlagsUpdate: (contactFlags: IContactFlags) => Promise<void> | void
  onReplacementContactCreate?: (contact: IContact) => Promise<void> | void
}

export type TNewContactProps = {
  isNewContact: true
  partner: IPartner
  contactFlags?: never
  onContactFlagsUpdate?: never
} & Pick<TContactEditorData, 'contact'> &
  Pick<TContactEditorHandles, 'onContactUpdate' | 'onClose' | 'onReplacementContactCreate'>

export type TExistedContactProps = { isNewContact: false } & TContactEditorData &
  TContactEditorHandles

export type TContactSettingProps = {
  /* Settings */
  isVisible: boolean
  size?: 'auto' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  source?: string
  requestPartnerId?: string
  isOnboarding?: boolean
}

export type TContactEditorContextProps = Pick<
  TContactSettingProps,
  'source' | 'requestPartnerId' | 'isOnboarding'
>

export type TContactEditorUpdateContextProps = Pick<
  TContactSettingProps,
  'source' | 'requestPartnerId'
>

export type THandlerResult = void | {
  hasError?: boolean
  message?: ReactNode
}
